import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Buyers',
    path: '/buyers'
  }, {
    name: 'Communities',
    path: '/communities'
  }, {
    name: 'Sellers',
    path: '/sellers'
  }, {
    name: 'The Collective',
    path: '/collective'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  const isHome = location.pathname === '/';
  const navBg = isScrolled || !isHome ? 'bg-sand shadow-sm' : 'bg-transparent';
  const textColor = isScrolled || !isHome ? 'text-navy' : 'text-white';
  return <header className={`fixed w-full top-0 z-50 transition-all duration-300 ${navBg}`} data-id="element-144" data-mp="olgnyyo0esgp">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-145" data-mp="3n3m6mepfugbd">
        <div className="flex justify-between items-center h-24" data-id="element-146" data-mp="3n19j7m0wvdqx">
          <Link to="/" className={`font-serif text-2xl tracking-wider uppercase ${textColor}`} data-id="element-147" data-mp="3s38myx0kccoe">
            Cabo Collection
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex space-x-8 items-center" data-id="element-148" data-mp="5nnu0lvd5svg">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm tracking-wide uppercase transition-colors hover:text-gold ${textColor} ${location.pathname === link.path ? 'font-semibold' : ''}`} data-id="element-149" data-mp="34ccx45fo3rjs">
                {link.name}
              </Link>)}
          </nav>

          {/* Mobile Menu Button */}
          <button className={`md:hidden p-2 ${textColor}`} onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-150" data-mp="3b01johvvz89q">
            {mobileMenuOpen ? <X size={24} data-id="element-151" data-mp="2ic5lt9ukzabd" /> : <Menu size={24} data-id="element-152" data-mp="2ibm51wgo2ryx" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-153" data-mp="2de452vkmnn32">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-sand border-t border-navy/10 overflow-hidden" data-id="element-154" data-mp="2dfozml6xz60x">
            <div className="px-4 pt-2 pb-6 space-y-1 flex flex-col" data-id="element-155" data-mp="2kzyrdv5juiy">
              {navLinks.map(link => <Link key={link.name} to={link.path} className="block px-3 py-4 text-navy text-lg font-serif border-b border-navy/5" data-id="element-156" data-mp="a754ws3rsbuv">
                  {link.name}
                </Link>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}